import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import DoneIcon from '@mui/icons-material/Done';
import Service from '../../util/Service';
import { Box, Button, Pagination, PaginationItem, Snackbar, Stack, Tooltip, Typography } from '@mui/material';
import { Toolbar } from 'react-simple-wysiwyg';
import SearchField from './SearchField';
import { Close, ContentCopy, Edit, OpenInFull } from '@mui/icons-material';
import ImagemDialog from './ImagemDialog';

const pageSize=10;

export default function GaleriaComp(props) {
    const { onAction, onClose } = props;
    const [page, setPage] = React.useState(1);
    const [filtro, setFiltro]= React.useState();
    const [lista, setLista] = React.useState([]);
    const [workItem, setWorkItem]= React.useState();
    const [open, setOpen]= React.useState(false);
    const [openSnack, setOpenSnack] = React.useState(false);

    
    React.useEffect(() => {
        buscaImagens();
    }, [])

    const visibleRows = React.useMemo(
        () =>
            [...lista]
                //.sort(getComparator(order, orderBy))
                .filter((el) => {
                    if( !filtro) return true;
                    if( el.tipo.toUpperCase() === filtro.toUpperCase() ) return true;
                    if( el.nome.indexOf(filtro)>=0 ) return true;
                    if( el.desk && el.desk.indexOf(filtro)>=0 ) return true;
                    return false;
                })
                .slice((page-1) * pageSize, (page-1) * pageSize + pageSize),
        [page, pageSize, lista, filtro],
    );
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenSnack(false);
      };
    function handleClick(item) {
        console.log('handleClick')
        if (onAction) onAction(item);
    }
    const handleChange = (event, value) => {
        setPage(value);
      };
    function buscaImagens() {
        const dado = {
            tamanhoPagina: 10,
            pagina: 0
        }
        Service.POST("/api/galeria", dado).then(r => {
            console.log(r);
            setLista(r);
        }).catch(erro => {
            console.log(erro);
        })
    }
    function onSearch(txt) {
        console.log( txt )
        setFiltro(txt);
    }
    function handleCopyClick(item){
        console.log( item );
        copyStringToClipboard("/api/getAnexoById/"+item.id);
    }
    function handleEditClick(item){
        setWorkItem(item)
        setOpen(true);
    }

    async function copyStringToClipboard(textToCopy) {
        try {
          await navigator.clipboard.writeText(textToCopy);
          setOpenSnack(true);
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
      }
    return (
        <Box component="section" sx={{ p: 0, border: '1px solid grey' }}>
            <Toolbar sx={{ height: "95px" }}>
                <Typography sx={{ flexGrow: 1 }}
                >
                    Galeria
                </Typography>
                <Pagination
                    count={ Math.ceil(lista.length / pageSize) } 
                    // count={pageSize} 
                    page={page} onChange={handleChange}
                    size="small" 
                    siblingCount={0} 
                    boundaryCount={1}
                />
                <SearchField handleSearch={onSearch} width={150} />
                <IconButton
                    size="small"
                    color="inherit"
                    onClick={() => {
                        console.log('-->')
                    }}
                >
                    <OpenInFull />
                </IconButton>
                <IconButton
                    size="small"
                    color="inherit"
                    onClick={() => {
                        if( onClose) onClose();
                    }}
                >
                    <Close />
                </IconButton>
            </Toolbar>
            <ImageList 
                sx={{ 
                    // width: 500, 
                    height: 450 
                }}
            >
                {visibleRows && visibleRows.map((item, index) => {
                    
                    return(
                    <ImageListItem key={index + "_" + item.i} >
                        <img style={{ objectFit: "contain" }}
                            //src={`/api/getAnexoById/${item.idArquivo}?w=248&fit=crop&auto=format`}
                            src={`/api/getAnexoById/${item.idArquivo}`}
                            alt={item.nome}
                            loading="lazy"
                            //width="250" height="200"                            
                        />
                        <ImageListItemBar
                            title={item.nome}
                            subtitle={item.desc}
                            actionIcon={
                                <Stack direction="row" spacing={0}>
                                    <Tooltip title="Copiar fonte da imagem">
                                        <IconButton
                                            sx={{ color: 'rgba(255, 255, 255, 0.94)' }}
                                            size='small'
                                            aria-label={`info about ${item.nome}`}
                                            onClick={() => handleCopyClick(item)}
                                        >
                                            <ContentCopy />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Mudar a imagem">
                                        <IconButton
                                            sx={{ color: 'rgba(255, 255, 255, 0.94)' }}
                                            size='small'
                                            aria-label={`info about ${item.nome}`}
                                            onClick={() => handleEditClick(item)}
                                        >
                                            <Edit />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Escolher essa imagem">
                                        <IconButton
                                            sx={{ color: 'rgba(255, 255, 255, 0.94)' }}
                                            size='small'
                                            aria-label={`info about ${item.nome}`}
                                            onClick={() => handleClick(item)}
                                        >
                                            <DoneIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            }
                        />
                    </ImageListItem>
                )
                })}
            </ImageList>
            {workItem && <ImagemDialog anexo={workItem} open={open} setOpen={setOpen}/> }
            <Snackbar
                open={openSnack}
                autoHideDuration={3000}
                onClose={handleCloseSnack}
                message="Fonte copiada para área de transferência"
            />
        </Box>
    );
}